// extracted by mini-css-extract-plugin
export default {"SelectorWrapper":"Select_SelectorWrapper__lyqct","title":"Select_title__3LoGh","Select":"Select_Select__6ktvF","input":"Select_input__Fvpes","inp_label":"Select_inp_label__qcuh-"};